import React, {Component} from 'react';
import {connect} from 'react-redux';

import moment from 'moment';

import {Field, reduxForm} from 'redux-form';
import {handleEditEmploymentHistory} from "../../../actions/application";
import {Col, Row} from "reactstrap";
import {DateField, InputField, SelectField} from "../../../../../validation/ReduxFormInput";
import BoolButtons from "../../../../../components/controls/buttons/BoolButtons";
import {states} from "../../../../../util/FormConstants";
import {normalizePhone} from "../../../../../util/normalizers";
import PolyUtil from "../../../../../util/PolyUtil";

class EditEmploymentHistoryForm extends Component {
    state = {
        isCurrentPosition: !this.props.end_date
    };

    setCurrentPosition = (val) => {
        !val && this.props.change('application_edit_employment_history', 'end_date', '');
        this.setState({isCurrentPosition: val === 'true'});
    };

    render() {

        const {handleSubmit, initialValues: {end_date}} = this.props;

        return (
            <div>
                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col xs={12} sm={4}>
                            <Field name="title" label="Job Title" component={InputField} type="text"/>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Field name="gross_income" label="Gross Income" placeholder="Annual" addon="$" component={InputField} type="number"/>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Field name="hours" label="Hours/week" placeholder="Estimate" component={InputField} type="number"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6} style={{display: 'flex', alignItems: 'center'}}>
                            Current Position?
                            <BoolButtons defaultValue={!end_date} onChange={this.setCurrentPosition}/>
                        </Col>
                        <Col xs={12} sm={3}>
                            <Field name="start_date"
                                   label="Start Date"
                                   component={DateField}/>
                        </Col>
                        {
                            !this.state.isCurrentPosition && (
                                <Col xs={12} sm={3}>
                                    <Field name="end_date"
                                           label="End Date"
                                           component={DateField}/>
                                </Col>
                            )
                        }
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}>
                            <Field name="employer_name" label="Employer" component={InputField} type="text"/>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Field name="employer_city" label="City" component={InputField} type="text"/>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Field name="employer_state" label="State" component={SelectField} options={states}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={4}><Field name="supervisor_name" label="Supervisor Name (optional)" placeholder="Optional" component={InputField} type="text"/></Col>
                        <Col xs={12} sm={4}><Field name="supervisor_phone" label="Supervisor Phone (optional)" placeholder="Optional" component={InputField}
                                                   normalize={normalizePhone}/></Col>
                        <Col xs={12} sm={4}><Field name="supervisor_email" label="Supervisor Email (optional)" placeholder="Optional" component={InputField} type="email"/></Col>
                    </Row>
                </form>
            </div>
        );
    }
}

const validate = values => {
    const errors = {};

    !values.title && (errors.title = 'Required');

    !values.employer_name && (errors.employer_name = 'Required');
    !values.employer_state && (errors.employer_state = 'Required');
    !values.employer_city && (errors.employer_city = 'Required');

    !values.gross_income && (errors.gross_income = 'Required');
    (values.gross_income && values.gross_income < 0) && (errors.gross_income = 'Cannot be less than zero');

    !values.start_date && (errors.start_date = 'Required');
    (values.start_date && values.end_date && moment(values.end_date).isBefore(moment(values.start_date))) && (errors.end_date = 'Must be later than start date');

    !values.hours && (errors.hours = 'Required');
    (values.hours && values.hours < 0) && (errors.hours = 'Cannot be less than zero');

    (values.supervisor_phone && values.supervisor_phone.length !== 12) && (errors.supervisor_phone = 'Please enter a valid phone number');

    return errors;
};

const submit = (data, dispatch, props) => {
    return dispatch(handleEditEmploymentHistory(props.editing, data)).then(() => props.onAdd());
};

EditEmploymentHistoryForm = reduxForm({
    form: 'application_edit_employment_history',
    validate,
    onSubmit: submit,
    enableReinitialize: true
})(EditEmploymentHistoryForm);

const mapStateToProps = (state, props) => {
    const position = state.tenant.application.employment_history_positions.find((pos) => {
        return pos.id === props.editing;
    });

    return {
        initialValues: Object.assign({}, position, {
            start_date: moment(position.start_date),
            end_date: position.end_date && moment(position.end_date),
            supervisor_phone: position.supervisor_phone && PolyUtil.formatPhone(position.supervisor_phone)
        })
    };
};

export default connect(mapStateToProps)(EditEmploymentHistoryForm);



// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/forms/EditEmploymentHistoryForm.js